module.exports = __webpack_public_path__ + "static/3-972f6a2643194d305823c420ef2b7366.jpg";